<template>
  <b-container fluid>
    <el-dialog
      :title="infoDialog.title"
      :visible.sync="infoDialog.show"
      width="40%"
      class="card-modal">
      <!-- v-html é usado aqui para renderizar HTML dinâmico, sanitizado com DOMPurify para prevenir XSS -->
      <div class="desc-itens" v-html="sanitizedText(infoDialog.text)"></div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="fecharDialogInfo">Fechar</el-button>
      </span>
    </el-dialog>

    <el-row :gutter="20">
      <el-col
      :xs="24" :sm="24" :md="24" :lg="9" :xl="9"
      >
        <div class="grid-content" style="padding:0">
          <DashboardIg v-if="igData && igData.length" :igData="igData ? igData[0] : []" :showBtn="false" @openDialog="setDialog('ig')" />
        </div>
      </el-col>
      <el-col
        :xs="24"
        :sm="8"
        :md="8"
        :lg="5"
        :xl="5"
      >
        <div class="grid-content">
          <div class="ig-content card-content" style="min-height: 250px;">
            <div class="dcard-header">
              <h4>Operacional</h4>
              <img class="ig-info" :src="infoSvg" width="50" height="50" alt="Info Operacional" @click="setDialog('operacional')" />
            </div>
            <div class="dcard-body">
              <IgSemiCircularChart v-if="igData && igData.length" :datas="igData[1]" />
            </div>
          </div>
        </div>
      </el-col>
      <el-col
      :xs="24"
        :sm="8"
        :md="8"
        :lg="5"
        :xl="5"
      >
        <div class="grid-content">
          <div class="ig-content card-content" style="min-height: 250px;">
            <div class="dcard-header">
              <h4>Gestão</h4>
              <img class="ig-info" :src="infoSvg" width="50" height="50" alt="Info Gestão" @click="setDialog('gestao')" />
            </div>
            <div class="dcard-body">
              <IgSemiCircularChart v-if="igData && igData.length" :datas="igData[2]" />
            </div>
          </div>
        </div>
      </el-col>
      <el-col
      :xs="24"
        :sm="8"
        :md="8"
        :lg="5"
        :xl="5"
      >
        <div class="grid-content">
          <div class="ig-content card-content" style="min-height: 250px;">
            <div class="dcard-header">
              <h4>Login</h4>
              <img class="ig-info" :src="infoSvg" width="50" height="50" alt="Info Login" @click="setDialog('login')" />
            </div>
            <div class="dcard-body">
              <IgSemiCircularChart v-if="igData && igData.length" :datas="igData[3]" />
            </div>
          </div>
        </div>
      </el-col>
      <!-- TABLE DETALHES -->
      <el-col
        :xs="24"
          :sm="24"
          :md="24"
          :lg="24"
          :xl="24"
        >
          <div class="grid-content">
            <div class="ig-content card-content">
              <div class="dcard-header">
                <h4>Detalhes</h4>
                <img class="ig-info" :src="infoSvg" width="50" height="50" alt="Info detalhes" @click="setDialog('detalhes')" />
              </div>
              <div class="dcard-body">
                <DetalhesIG />
              </div>
            </div>
          </div>
        </el-col>
    </el-row>
  </b-container>
</template>
<script>
import DashboardIg from "@/components/Dashboard/Ig";
import IgSemiCircularChart from "@/components/Dashboard/chart/IgSemiCircularChart.vue";
import DetalhesIG from "./DetalhesIG.vue";

const startDialog = () => {
  return {
    show: false,
    text: '',
    title: ''
  }
}

export default {
  components: {
    DashboardIg,
    IgSemiCircularChart,
    DetalhesIG
},
  name: 'DashIndiceDeGestaoboard',
  data() {
    return {
      igData: [],
      infoSvg: require(`@/assets/info.svg`),
      infoDialog: startDialog()
    }
  },
  methods: {
    async getIgTotal() {
      try {
          this.igLoading = true;

          const response = await this.axios.get(this.$urls.IG_OBTER_TOTAL, {
              params: {
                apenasTotal: false,
              }
          });
          
          if(response.status !== 200){
              this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
              return;
          }
          
          this.igData = response.data;
          this.trackingF360(this, 'IG','IG total geral');
      } catch(err) {

        console.error(err)
          this.$notify.error({
              title: 'Erro interno',
              message: `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
              position:'top-left'
          });
      }finally {
        this.igLoading = false
      }
    },
    fecharDialogInfo() {
      this.infoDialog = startDialog(); // fechar e reset
    },
    setDialog(type) {
      switch(type) {
        case 'operacional':
        this.infoDialog = {
          show: true,
          text: `
            <p>As métricas Operacionais possuem as seguintes informações e pesos:</p>
            <p>15% Fechamento de Caixa: </p>
            <ul>
              <li>Fechamento dos Caixas</li>
              <li>Fechamento dos Períodos</li>
            </ul>
            <p>25% Cartões:</p>
            <ul>
              <li>Taxas Cadastradas</li>
              <li>Cartões Conciliados</li>
              <li>PDVs Conciliados</li>
              <li>Fechamento de Período</li>
              <li>Subida de Arquivos EDI</li>
              <li>Criação de Registros de PDV</li>
            </ul>
            <p>25% Títulos:</p>
            <ul>
              <li>Geração de Títulos a Pagar</li>
              <li>Geração de Títulos a Receber</li>
              <li>Liquidação de Títulos a Pagar</li>
            </ul>
            <p>15% Nota Fiscal Eletrônica:</p>
            <ul>
              <li>Notas Manifestadas</li>
              <li>Geração de Títulos</li>
              <li>Cadastro de Webservice</li>
            </ul>
            <p>20% Contas:</p>
            <ul>
              <li>Conciliação de Parcelas de Cartão</li>
              <li>Conciliação de Parcelas de Título</li>
              <li>Conciliação de Transferências</li>
              <li>Conciliação de Movimentos Bancários</li>
              <li>Batimento Geral de Conciliações</li>
              <li>Fechamento de Período</li>
            </ul>
          `,
          title: 'Info Operacional'
        }
        break;
        case 'gestao':
        this.infoDialog = {
          show: true,
          text: `
            <p>
              As métricas de Gestão possuem as seguintes informações e pesos:
            </p>
            <ul>
              <li>10%: Realização de pesquisas na página de Plano Orçamentário</li>
              <li>50%: Realização de pesquisas na página de DRE</li>
              <li>40%: Realização de pesquisas na página de Fluxo de Caixa    </li>
            </ul>
          `,
          title: 'Info Gestão'
        }
        break;
        case 'login':
        this.infoDialog = {
          show: true,
          text: `<p>A métrica de Login leva em consideração a quantidade de dias logados no mês analisado.</p>`,
          title: 'Info Login'
        }
        break;
        case 'detalhes':
        this.infoDialog = {
          show: true,
          text: `
          <p>Para que as unidades tenham um bom desempenho e a marca torne-se referência no mercado, a rede deve fornecer um suporte de qualidade e dar bastante atenção para os franqueados. Para isso, a F360 disponibiliza informações sobre o Índice de Gestão de cada Grupo de lojas Franqueadas.</p>
          <p>Esse índice pode ajudá-los a entender mais sobre os problemas internos da rede e como o franqueador pode se preparar para prestar um suporte qualificado aos franqueados, conhecendo as principais dores de cada Grupo.</p>
          <p>
            IG da Plataforma F360 Finanças é calculado como um <b>Média Ponderada</b> de todos os subíndices.
            Para o cálculo do IG total utilizamos Métricas <b>Operacionais</b>, de <b>Gestão</b> e <b>Logins</b>.
            Os Índices são classificados em <b>4 Níveis</b>: IG, Índice de Tipo de Funcionalidade, Índice de Funcionalidade e Subíndices.
          </p>
          <p>
            O IG Total é calculado por cada grupo de lojas dos franqueados através de média ponderada, avaliando 3 grupos de informações:
            65% relacionado a Métricas Operacionais : Fechamento de Caixa, Cartões, Títulos, Nota Fiscal Eletrônica e Contas
            20% relacionado a Métricas de Gestão: Plano Orçamentário, DRE e Fluxo de Caixa
            15% relacionado a métricas de Acesso: Login
          </p>
          <p>As métricas Operacionais possuem as seguintes informações e pesos:<br>
          15% Fechamento de Caixa:</p>
          <ul>
            <li>Fechamento dos Caixas</li>
            <li>Fechamento dos Períodos</li>
          </ul>
          <p>25% Cartões:</p>
          <ul>
            <li>Taxas Cadastradas</li>
            <li>Cartões Conciliados</li>
            <li>PDVs Conciliados</li>
            <li>Fechamento de Período</li>
            <li>Subida de Arquivos EDI</li>
            <li>Criação de Registros de PDV</li>
          </ul>
          <p>25% Títulos:</p>
          <ul>
            <li>Geração de Títulos a Pagar</li>
            <li>Geração de Títulos a Receber</li>
            <li>Liquidação de Títulos a Pagar</li>
          </ul>
          <p>15% Nota Fiscal Eletrônica:</p>
          <ul>
            <li>Notas Manifestadas</li>
            <li>Geração de Títulos</li>
            <li>Cadastro de Webservice</li>
          </ul>
          <p>20% Contas:</p>
          <ul>
            <li>Conciliação de Parcelas de Cartão</li>
            <li>Conciliação de Parcelas de Título</li>
            <li>Conciliação de Transferências</li>
            <li>Conciliação de Movimentos Bancários</li>
            <li>Batimento Geral de Conciliações</li>
            <li>Fechamento de Período</li>
          </ul>
          <p>
            As métricas de Gestão possuem as seguintes informações e pesos:
            10%: Realização de pesquisas na página de Plano Orçamentário
            50%: Realização de pesquisas na página de DRE
            40%: Realização de pesquisas na página de Fluxo de Caixa  
          </p>
          <p>A métrica de Login leva em consideração a quantidade de dias logados no mês analisado.</p>
          `,
          title: 'Info Detalhes de IG'
        }
        break;
        case 'ig':
        this.infoDialog = {
          show: true,
          text: `
            <p>O IG é calculado por cada grupo de lojas dos franqueados através de média ponderada, avaliando 3 grupos de informações:</p>
            <ul>  
              <li>65% relacionado a Métricas Operacionais: </li>Fechamento de Caixa, Cartões, Títulos, Nota Fiscal Eletrônica e Contas
              <li>20% relacionado a Métricas de Gestão: Plano Orçamentário, DRE e Fluxo de Caixa</li>
              <li>15% relacionado a métricas de Acesso: Login</li>
            </ul>
          `,
          title: 'Info Indice de Gestão'
        }
        break;
      }
    }
  },
  mounted() {
    this.getIgTotal()
  }
}
</script>
<style lang="scss">
.grid-content {
  border-radius: 5px;
  background: #fff;
  min-height: 205px;
  box-shadow: 1px 2px 1px #d3d3d3;
  .ig-radial-chart {
    border: none;
  }
  .ig-content.card-content {
    padding: 5px 10px 10px;
  }
  h4 {
    display: inline-block;
  }
}
.el-row {
  .el-col {
    margin-bottom: 1rem;
  }
  &:last-child {
    margin-bottom: 0;
  }
}
.ig-info {
  width: 16px;
  height: 16px;
  cursor: pointer;
  display: inline-block;
  margin-left: 10px;
}
.desc-itens {
  hyphens: auto;
  text-align: justify;
  word-break: normal;
}
</style>
